// Copyright (c) StrangeBee 2023

import React, { ReactElement, useState, useRef, useEffect } from 'react';
import { useLocalMessage } from '@Helpers/locale';
import { THButton } from '@Molecules/Inputs/THButton/THButton';
import { THForm } from '@Molecules/THForm/THForm';
import { THTextArea } from '@Molecules/Inputs/THTextArea/THTextArea';

interface FormCommentProps {
    message?: string;
    onSubmit?: (text: string) => void;
    onReset?: () => void;
    placeholder?: string;
}

export const FormComment = ({ message = '', onSubmit, onReset, placeholder }: FormCommentProps): ReactElement => {
    const local = useLocalMessage();

    const [content, setContent] = useState(message);
    const refGrowDiv = useRef<HTMLDivElement>(null);

    const onChangeHandler = (e: any) => {
        setContent(e.target.value);
    };

    const onSubmitHandler = () => {
        onSubmit?.(content);
        setContent('');
    };

    const onPressEnterHandler = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (content.trim() === '') {
            e.preventDefault();
            return;
        }

        if (!e.shiftKey) {
            e.preventDefault();
            onSubmitHandler();
        }
    };

    useEffect(() => {
        if (refGrowDiv.current) {
            refGrowDiv.current.dataset.replicatedValue = content;
        }
    }, [content]);

    return (
        <div className="comment-form">
            <THForm className="comment-form__wrapper" onFinish={onSubmitHandler}>
                <div ref={refGrowDiv} className="comment-form__grow">
                    <THTextArea
                        onChange={onChangeHandler}
                        className="comment-form__input"
                        placeholder={placeholder}
                        value={content}
                        onPressEnter={onPressEnterHandler}
                    />
                </div>
                <footer className="comment-form__tool">
                    {onReset ? (
                        <THButton danger type="link" color="red" htmlType="reset" onClick={onReset}>
                            {local('comment.cancel')}
                        </THButton>
                    ) : null}
                    <THButton type="primary" htmlType="submit" disabled={content.trim() === ''}>
                        {local('comment.submit')}
                    </THButton>
                </footer>
            </THForm>
        </div>
    );
};
